import { Link } from "react-router-dom";

const entries = [
  {
    title: "电影",
    subtitle: "院线与经典片单",
    icon: "ri-film-line",
    to: "/category/movie",
    meta: "8 部精选",
  },
  {
    title: "电视剧",
    subtitle: "热播剧集与新番",
    icon: "ri-tv-2-line",
    to: "/category/tv",
    meta: "6 部连载",
  },
  {
    title: "影视资讯",
    subtitle: "行业动态与影评",
    icon: "ri-newspaper-line",
    to: "/category/news",
    meta: "每日更新",
  },
  {
    title: "影视专题",
    subtitle: "主题化片单聚合",
    icon: "ri-stack-line",
    to: "/specials",
    meta: "3 个专题",
  },
];

export default function QuickLinks() {
  return (
    <section className="relative z-10 -mt-10 md:-mt-12">
      <div className="shell">
        <div className="grid grid-cols-2 gap-3 rounded-lg border border-background-200 bg-background-50 p-3 md:grid-cols-4 md:gap-4 md:p-4">
          {entries.map((entry) => (
            <Link
              key={entry.title}
              to={entry.to}
              className="group flex cursor-pointer items-center gap-3 rounded-md border border-transparent px-2 py-3 transition hover:border-background-200 hover:bg-background-100 md:px-3"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50 md:h-11 md:w-11">
                <i className={`${entry.icon} text-lg`}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-1.5">
                  <span className="whitespace-nowrap text-sm font-medium text-foreground-950">
                    {entry.title}
                  </span>
                  <i className="ri-arrow-right-up-line text-xs text-foreground-300 transition group-hover:text-accent-600"></i>
                </span>
                <span className="mt-0.5 block truncate text-[11px] text-foreground-500">
                  {entry.subtitle}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}